import { Button } from "antd";
import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { useSelector } from "react-redux";

const CarouselSection = () => {
  const { carouselData } = useSelector((state) => state.home);

  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 1,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  return (
    <div className="carouselContainer">
      <Carousel responsive={responsive}>
        {carouselData.map((item, index) => {
          return <CarouselItem key={index} data={item} />;
        })}
      </Carousel>
    </div>
  );
};

const CarouselItem = ({ data }) => {
  return (
    <div className="carouselItem" style={{ backgroundColor: data.color }}>
      <div className="carouselItemLeft">
        <h2 className="title">{data.title}</h2>
        <p className="description">{data.description}</p>
        <div className="buttonBox">
          <Button type="primary" className="getStartedButton">
            Get Started
          </Button>
          <Button type="text" className="learnMoreButton">
            Learn More
          </Button>
        </div>
      </div>
      <div className="carouselItemRight">
        <img src={data.imageUrl} />
      </div>
    </div>
  );
};

export default CarouselSection;
